import { render, staticRenderFns } from "./AdminSpareCatalog.vue?vue&type=template&id=5acbb6d5&scoped=true"
import script from "./AdminSpareCatalog.vue?vue&type=script&lang=js"
export * from "./AdminSpareCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acbb6d5",
  null
  
)

export default component.exports